/**
 * 项目管理-项目信息-相册
 * luxinwen
 * 2023-03-20
 */
<template>
  <div>
    <Drawer class="drawer" :title="title" v-model="myValue" width="900" :before-close="beforeClose">
      <Form ref="editForm" :model="formData" :rules="formRule" :label-width="100">
        <div class="page-main-content-thead">项目图片</div>
        <div class="padding-b-20">
          <sp-upload v-model="formData.picUrlStrings" :img-width="1080" :img-height="720" move></sp-upload>
          <p class="text-tips">请上传宽高为1080*720的图片</p>
        </div>
        <div class="page-main-content-thead">项目视频</div>
        <div class="padding-b-20">
          <sp-upload v-model="formData.videoUrlStrings" :max-size="51200" :format="['MP4', 'WebM', 'Ogg']" video move></sp-upload>
          <p class="text-tips">为保证播放效果，请尽量上传宽高比为3:2的视频</p>
        </div>
      </Form>
      <div class="drawer-foot">
        <Button type="primary" @click="submit">提交</Button>
      </div>
      <Spin size="large" fix v-if="isLoading"></Spin>
    </Drawer>
  </div>
</template>

<script>
  const formData = {
    ownerId: null,  // 楼盘或户型id
    picUrlStrings: [],  // 图集合，英文逗号分割
    videoUrlStrings: [],  // 视频集合，英文逗号分割
  };

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        myValue: this.value,  // 是否显示抽屉
        isInit: false,        // 是否初始化
        isLoading: false,     // 是否加载中
        formData: Object.assign({}, formData),
        formRule: {},
        backupData: {}
      };
    },
    computed: {
      title() {
        return '项目相册';
      },
      isEqual() {
        return this.deepEqual(this.formData, this.backupData);
      }
    },
    methods: {
      /**
       * 初始化数据
       */
      initData(data = {}, isInit = false) {
        this.formData = this.deepCopy(formData);
        Object.keys(this.formData).forEach(item => {
          if (data.hasOwnProperty(item)) {
            this.formData[item] = data[item];
          }
        });
        if (isInit) {
          this.$nextTick(() => {
            this.backupData = this.deepCopy(this.formData);
            this.isInit = true;
          });
        }
      },
      /**
       * 获取数据
       */
      getData() {
        let isInit = !this.data.id;
        this.initData(this.data, isInit);
        if (isInit) return;
        this.$axios({
          url: this.$api.project.queryPhotoList,
          data: {
            ownerId: this.data.id
          },
          beforeSend: () => {
            this.isLoading = true;
          },
          complete: () => {
            this.isLoading = false;
          }
        }).then(data => {
          let list = data || [];
          let photoData = {
            ownerId: this.data.id,
            picUrlStrings: list.filter(item => item.mediaType === 1),
            videoUrlStrings: list.filter(item => item.mediaType === 2)
          };
          this.initData(photoData, true);
        });
      },
      /**
       * 关闭前的回调
       */
      beforeClose() {
        return new Promise((resolve, reject) => {
          if (!this.isInit) {
            // 如果未初始化时快速点击关闭，则不做处理
          } else if (this.isEqual) {
            this.myValue = false;
          } else {
            this.$confirm('数据变更后未保存，是否直接关闭？').then(() => {
              this.myValue = false;
            });
          }
        });
      },
      /**
       * 提交
       */
      submit() {
        if (this.formData.picUrlStrings.length === 0) {
          return this.notice('请上传项目图片');
        }
        this.$refs.editForm.validate(valid => {
          if (valid) {
            this.$confirm('确定要提交吗？').then(() => {
              let url = this.$api.project.addPhoto;
              let data = Object.assign({}, this.formData);
              data.picUrlStrings = data.picUrlStrings.map(item => item.url).join(',');
              data.videoUrlStrings = data.videoUrlStrings.map(item => item.url).join(',');
              this.save(url, data);
            });
          }
        });
      },
      /**
       * 保存
       */
      save(url, data) {
        this.$axios({
          url,
          data,
          beforeSend: () => {
            this.isLoading = true;
          },
          complete: () => {
            this.isLoading = false;
          }
        }).then(data => {
          this.notice({
            type: 'success',
            desc: '提交成功'
          });
          this.myValue = false;
          this.$emit('success');
        });
      }
    },
    watch: {
      value(val) {
        this.myValue = val;
        if (this.myValue) {
          // 获取数据
          this.getData();
          // 隐藏页面滚动条
          document.querySelector('body').classList.add('hidden');
          // 重置内容域滚动条
          this.$nextTick(() => {
            let $drawer = document.querySelector('.drawer .ivu-drawer-body');
            if ($drawer) $drawer.scrollTo(0, 0);
          });
        } else {
          // 清除表单验证效果
          this.$refs.editForm && this.$refs.editForm.resetFields();
          // 重置初始化状态
          this.isInit = false;
          // 恢复页面滚动条
          document.querySelector('body').classList.remove('hidden');
        }
      },
      myValue(val) {
        this.$emit('input', val);
      }
    }
  };
</script>